import { useEffect } from 'react';
import { onMessage } from 'firebase/messaging';
import { messaging } from './firebase';
import { toast } from 'react-toastify';

export default function useFCM() {
  useEffect(() => {
    console.log('🚀 useFCM hook mounted');

    const unsubscribe = onMessage(messaging, async (payload) => {
      console.log('📩 Foreground message received:', payload);

      const title = payload.data?.title || 'Notification';
      const body = payload.data?.body || '';

      if (Notification.permission !== 'granted') return;

      const reg = await navigator.serviceWorker.ready;
      if (!reg) {
        console.log('❌ SW not ready');
        return;
      }

      try {
        await reg.showNotification(title, {
          body,
          vibrate: [200, 100, 200],
          requireInteraction: true,
          tag: 'ktc-notification',
          data: { url: '/' },
        });
        console.log('✅ Notification call SUCCESS');
      } catch (err) {
        console.error('🔥 Notification error:', err);
      }

      // 🔹 In-page fallback for active tab
      if (document.visibilityState === 'visible') {
        console.log('👀 Tab is active → show in-page toast instead');

        toast.info(`${title}: ${body}`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: 'light',
        });
      }
    });

    return () => unsubscribe();
  }, []);
}
